// extracted by mini-css-extract-plugin
module.exports = {"description":"DescriptionListItemDescription-description-3Ul_p"};